// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';


export default function ConfirmSendNotificaitonDialog(props) {

  const { onCancelClick, onMoveClick, onMoveAndSendClick } = props;

  const handleCancelClick = () => {
    onCancelClick && onCancelClick();
  }


  const handleMoveClick = () => {
    onMoveClick && onMoveClick();
  }

  const handleMoveAndSendClick = () => {
    onMoveAndSendClick && onMoveAndSendClick();
  }

  const openDialog = props.open || false

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      open={openDialog}
    >
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Do you want to move the file(s) and send notification now?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button onClick={handleMoveClick} variant="contained" >Move Only</Button>
        <Button onClick={handleMoveAndSendClick} variant="contained" >Move & Send Email</Button>
      </DialogActions>
    </Dialog>

  );
}

ConfirmSendNotificaitonDialog.propTypes = {
  open: PropTypes.bool,
  onMoveClick: PropTypes.func,
  onMoveAndSendClick: PropTypes.func,
  onCancelClick: PropTypes.func,
};